export const AUTHORITY_AUDIT_GROUP = 'audit.authority';
export const VERSION_HISTORY_PAGE_SIZE_SETTING = 'records.page.size';
export const VERSION_HISTORY_ENABLED_SETTING = 'enabled';
